import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const REPORT = React.lazy(()=> import(/* webpackChunkName: "MessageCDRReport" */'./components'));
const CONVERSATION_LIST = React.lazy(()=> import(/* webpackChunkName: "MessageCDRReport" */'./components/ConversationList'));

const routes = () =>
  (
    <React.Fragment>
  <PrivateRoute exact path="/reporting/message-cdr-report" component={REPORT} />
  <PrivateRoute exact path="/reporting/message-cdr-report/:id" component={CONVERSATION_LIST} />
    </React.Fragment>
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/MessageCDRReport/routes.js